import { graphql } from '@search/gql-client/src';

export const SavingSearchMutation = graphql`
  mutation SavingSearchMutation($email: String, $title: String!, $filters: ProfessionalSearchInput!) {
    savingSearch(email: $email, title: $title, filters: $filters) {
      email
      isSuccess
    }
  }
`;
